import { render } from "./PasswordResetConfirmScreen.vue?vue&type=template&id=0071ceaa&scoped=true"
import script from "./PasswordResetConfirmScreen.vue?vue&type=script&lang=js"
export * from "./PasswordResetConfirmScreen.vue?vue&type=script&lang=js"

import "./PasswordResetConfirmScreen.vue?vue&type=style&index=0&id=0071ceaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0071ceaa"]])

export default __exports__